import { combineReducers } from 'redux'

import accountCurrency from './accountCurrency'
import { adAccountsReducer } from './adAccountsSlice'
import adConstructor from './adConstructor'
import data from './adsData'
import allAccount from './allAccount'
import { currentAdSetReducer } from './currentAdSetSlice'
import { currentCampaignReducer } from './currentCampaignSlice'
import customAudience from './customAudience'
import table from './table'
import { targetingReducer } from './targetingSlice'
import wizard from './wizard'

export const adsReducer = combineReducers({
  data,
  table,
  wizard,
  adConstructor,
  targeting: targetingReducer,
  currentCampaign: currentCampaignReducer,
  currentAdSet: currentAdSetReducer,
  accountCurrency,
  customAudience,
  account: adAccountsReducer,
  allAccount,
})
